export class VerificationNewParkerSitesEntity {
    phoneNumber;
    siteIds;
    fromGmt;

    constructor(phoneNumber = '', siteIds = [], fromGmt = false) {
        this.phoneNumber = phoneNumber;
        this.siteIds = siteIds;
        this.fromGmt = fromGmt;
    };
};